import React from "react";
import i18n from "../../../../i18n/i18n";
import Loader from "../../../../common/components/shared/loader/loader";
import {AxiosResponse} from "axios";
import {Api} from "../../../../helpers/api";
import {HttpErrorModel} from "../../../../common/models/httpError";
import {HttpError} from "../../../../common/components/shared/httpError/httpError";

interface ModifyItemState<T> {
    item: T | undefined | null;
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
}

export default abstract class ModifyItem<T> extends React.Component <any, ModifyItemState<T>> {
    protected constructor(props: any) {
        super(props);
        this.state = {
            item: undefined,
            response: undefined
        };
    }

    private get item() {
        return this.state.item;
    }

    protected getItem(getItem: AxiosResponse<T>) {
        this.setState({
            item: getItem?.data || null,
            response: getItem
        });
    }

    protected renderHeader(header: string) {
        return (
            <div className="header">
                {header}
            </div>
        );
    }


    protected renderContent(form: JSX.Element) {
        if (!Api.isSuccess(this.state.response)) {
            return <HttpError
                response={this.state.response}
                cause={i18n.t("dictionaries.itemRetrievalErrorSuffix")}
            />;
        } else if (this.item) {
            return form;
        } else {
            return (
                <Loader/>
            );
        }
    }
}
